import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import "../../styles/menuopcoes.css"
import { Link, useLocation } from 'react-router-dom';

function MenuOpcoesDashboard(props: menuOpcoes) {

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");
  const grupo = paramsUrl.get("grupo");

  return (
    <div>
      <Link id="menuOpcoes" to={`/dashboard?idProjeto=${idProjeto}&grupo=${grupo}`}>
        {props.icone}
        <p id='tituloMenu'>{props.titulo}</p>
      </Link>
    </div>
  )
}

export default MenuOpcoesDashboard;